export var DEFAULT_MAXIMUM_SLOTS = 5;
export var DEFAULT_PAGE_NUMBER = 1;